module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("1. Gambling in America")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Gambling Economics")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Gambling: 1900s–1920s")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Louis Cella: Horse Track Kingpin")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Barney Schreiber: Turf Man")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Henry “Kid” Becker: Bookmaker")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. John Walters: Betting Commissioner")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Thomas “Chicago” O’Brien: Track Bettor")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Senorita Concepion de Hara: Faro Gambler")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Honest John Kelly: Casino Owner")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Mont Tennes: Casino, Bookie, Wire Service")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Moses “Mo” Annenberg: Publisher, Wire Service")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Big Jim O’Leary: South Side Gambler")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Broadway Jack Doyle: Handicapper")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Tom Kerney: Bookmaker, Oddsmaker")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Tom Shaw: Bookmaker, Oddsmaker")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Tim Mara: Bookmaker, Sports Team Owner")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Charles Bidwill Sr.: Track Owner, Sports Team Owner")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Betting on the East Side: 1930s–1950")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Open Gambling in New Orleans: 1930s–1950")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Organized Crime")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Kefauver Hearings: Criminal Impact on Gambling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. James J. Carroll: Oddsmaker, Kefauver Hearings")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Gambling Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Today’s Bookmakers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Current Operations")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Future Direction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f3b010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0